const locale = {
  APPLICATIONS: 'Applications',
  DASHBOARDS: 'Dashboards',
  CALENDAR: 'Calendar',
  ECOMMERCE: 'E-Commerce',
  ACADEMY: 'Academy',
  MAIL: 'Mail',
  TASKS: 'Tasks',
  FILE_MANAGER: 'File Manager',
  CONTACTS: 'Contacts',
  CHAT: 'Chat',
  SCRUMBOARD: 'Scrumboard',
  NOTES: 'Notes',
};

export default locale;
